import { FormattedMessage } from 'react-intl';
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';

const NotFoundPartner = () => (
    <NotFoundState
        outerClassName='border-none'
        headline={<FormattedMessage id='intl-msg:network.partnersTable.emptySearch.title' />}
        message={<FormattedMessage id='intl-msg:network.partnersTable.emptySearch.message' />}
    />
);

export default NotFoundPartner;
